import { Button } from "@/components/ui/button";
import React, { useMemo, useState } from 'react';

const TabList = ({
  data = [],
  filterKeys = [],
  selectedFilters = {},
  setSelectedFilters = () => { },
  onApply,
  className = "",
}) => {
  const [searchTerms, setSearchTerms] = useState({});

  // ✅ Prepare filter options (label + count kept together)
  const filterOptions = useMemo(() => {
    const result = {};
    filterKeys.forEach((key) => {
      // Instead of extracting only one field, keep the whole object
      const uniqueValues = [
        ...new Map(
          data.map((item) => [item[key], { label: item.label, count: item.count, key: item.key }])
        ).values(),
      ];
      result[key] = uniqueValues;
    });
    return result;
  }, [data, filterKeys]);

  // ✅ Always replace with single value
  const handleSelect = (key, value) => {
    setSelectedFilters({
      [key]: value, // store selected object, not just string
    });
  };

  return (
    <div
      className={`font-sans w-72 bg-white dark:bg-gray-900 shadow-lg rounded-2xl p-4 relative ${className}`}
    >
      <div className="max-h-80 overflow-y-auto pr-1">
        {filterKeys.map((key, idx) => {
          const filteredOptions = (filterOptions[key] || []).filter((option) =>
            String(option)
              .toLowerCase()
              .includes((searchTerms[key] || "").toLowerCase())
          );

          return (
            <div key={key} className="font-sans mb-3">
                    <div className="flex flex-col gap-1 pl-2 mt-1">
                {filteredOptions.map((option) => (
                  <label
                    key={option.key} // ✅ unique key
                    className="flex items-center justify-between text-sm text-gray-800 dark:text-gray-200 cursor-pointer"
                  >
                    <div className="flex items-center gap-2">
                      <input
                        type="radio"
                        name={key}
                        checked={selectedFilters[key] === option.label} // ✅ compare by key
                        onChange={() => handleSelect(key, option.label)}  // ✅ store key
                        className="h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500 accent-blue-500"
                      />
                      <span>{option.label} ({option.count ?? 0})</span>
                    </div>
                  </label>
                ))}

              </div>

              {idx < filterKeys.length - 1 && (
                <hr className="border-t border-gray-200 dark:border-gray-700 mt-3" />
              )}
            </div>
          );
        })}
      </div>
      {/* Buttons */}
      <div className="flex gap-2 mt-3">
        <Button
          variant="default"
          onClick={() => onApply?.(selectedFilters)}
          className="flex-1"
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default TabList;
